<template>
  <div class="page-container">

    <transition :name="transitionName">
      <div :key="currentPart" class="page">
        <component
            :is="pages[currentPart]"
            @route_jump="route_jump"/>
      </div>
    </transition>

    <div v-for="n in pages.length" :key="n">
      <DotComponents :is-activity="currentPart === n-1"
                     @click="dotClick(n)"
                     :style="{ position: 'absolute', right: '30px', top: `${(n - 1)*10 + 20}%`}"

      ></DotComponents>
    </div>
  </div>

</template>

<script setup>
import part1 from '../components/IndexPart1.vue';
import part2 from '../components/IndexPart2.vue';
import part3 from '../components/IndexPart3.vue';
import part4 from '../components/IndexPart4.vue';
import part5 from '../components/IndexPart5.vue';
import DotComponents from '@/components/dotComponents.vue'
import {onMounted, onUnmounted, ref} from 'vue';
import router from "@/router";
import eventBus from '@/utils/eventBus';

// 页面数据和当前页面索引
const pages = ref([part1, part2, part3, part4, part5]);
const currentPart = ref(0);
const transitionName = ref("slide-down");
let lastScrollTime = 0;  // Track the last scroll time
const cooldown = 1000;    // Set cooldown to 1 seconds (3000 ms)

const sendEvent = () => {
  eventBus.emit('changePart', currentPart);
};

const dotClick = (index) => {

  if (currentPart.value < index - 1) {
    transitionName.value = "slide-down";
  } else {
    transitionName.value = "slide-up";
  }
  currentPart.value = index - 1
}
// 切换到下一页
const showNextPage = () => {
  if (currentPart.value < pages.value.length - 1) {
    currentPart.value++;
    transitionName.value = "slide-down";
  }
};

// 切换到上一页
const showPreviousPage = () => {
  if (currentPart.value > 0) {
    currentPart.value--;
    transitionName.value = "slide-up";
  }
};

// 监听滑动事件
const handleScroll = (event) => {
  const currentTime = Date.now();
  if (currentTime - lastScrollTime < cooldown) {
    return;  // Ignore this scroll event if it's too soon after the last one
  }

  lastScrollTime = currentTime;

  if (event.deltaY > 0) {
    showNextPage();
  } else if (event.deltaY < 0) {
    showPreviousPage();
  }
  sendEvent();
};

onMounted(() => {
  document.body.style.overflow = "hidden";
  window.addEventListener("wheel", handleScroll);
});

onUnmounted(() => {
  document.body.style.overflow = "";
  window.removeEventListener("wheel", handleScroll);
});

function route_jump(val) {
  router.push(val.route);
}
</script>

<style scoped>
body {
  overflow: hidden;
}

.page-container {
  position: relative;
  perspective: 1000px; /* 设置透视效果 */
  width: 100%;
  height: 100vh;
  background-color: grey;
}

.page {
  position: absolute;
  width: 100%;
  height: 100%;
}

/* 向下滑动覆盖效果 */
.slide-down-enter-from {
  transform: translateY(100%); /* 从下方进入 */
}

.slide-down-enter-to {
  transform: translateY(0);
}

.slide-down-leave-to {
  transform: translateY(-30%); /* 向上退出 */
}

.slide-down-enter-active, .slide-down-leave-active {
  transition: transform 0.8s ease;
}

/* 向上滑动覆盖效果 */
.slide-up-enter-from {
  transform: translateY(-100%); /* 从上方进入 */
}

.slide-up-enter-to {
  transform: translateY(0);
}

.slide-up-leave-to {
  transform: translateY(30%); /* 向下退出 */
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.8s ease;
}

/deep/ .fp-overflow {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.dots {
  position: absolute;
  transform: translateY(-50%); /* 垂直居中 */
  display: flex;
  flex-direction: column; /* 垂直排列 */
  align-items: center; /* 水平居中对齐 */
  color: white;
  font-size: 3rem;
  right: 20px;
  height: 50px;
  width: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 50%;


}


.dots_border {
  border: 1px solid rgba(255, 255, 255, 0.7);
}

.dots_border_grey {
  border: 1px solid rgba(181, 181, 181, 0.7);
}


.dot {
  display: block;
  width: 10px; /* 圆点的大小 */
  height: 10px; /* 圆点的大小 */
  background-color: rgba(255, 255, 255, 0.7); /* 圆点颜色 */
  border-radius: 50%; /* 圆形 */
  margin-top: 20px;

}

.dot_grey {
  display: block;
  width: 10px; /* 圆点的大小 */
  height: 10px; /* 圆点的大小 */
  background-color: rgba(181, 181, 181, 0.7); /* 圆点颜色 */
  border-radius: 50%; /* 圆形 */
  margin-top: 20px;
}


</style>
